import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GenericAbsService } from '../utils/generic-abs-service';
import { moduleConfigToken, AbdaliModuleConfig } from '../app.module';
import { ApiResponse, SliderHomeDto, PushRequestDto } from '../objects';

@Injectable()
export class ConfigService extends GenericAbsService<ApiResponse> {

    constructor(@Inject(moduleConfigToken) private config: AbdaliModuleConfig, private http: HttpClient) {
        super(config.baseUrl, http);
    }

    getImageSliders() {
        const endpoint = `/api/v1/config/slider-images`;
        return this.getAll(endpoint);
    }

    insertImageSlider(endpoint: string = null, dto: SliderHomeDto, file: File, headers?: HttpHeaders) {
        // if (headers) {
        //     if (headers.has('Content-Type') === false) {
        //         headers.append('Content-Type', 'application/multipart-form');
        //     }
        // }
        // else {
        //     headers = new HttpHeaders({
        //         'Content-Type': 'application/multipart-form'
        //     });
        // }
        endpoint = endpoint == null ? `/api/v1/config/slider-images` : endpoint;
        const formData = new FormData();
        formData.append('title', dto.title);
        formData.append('files', file, file.name);
        return this.post(endpoint, formData, headers);
    }

    deleteImageSlider(endpoint: string = null, id: number) {
        endpoint = endpoint == null ? `/api/v1/config/slider-images` : endpoint;
        return this.delete(endpoint, id);
    }

    getCartLimit(endpoint: string = null) {
        endpoint = endpoint == null ? '/api/v1/config/cart-limit' : endpoint;
        return this.getAll(endpoint);
    }

    updateCartAmount(amount: number, headers?: HttpHeaders) {
        // if (headers) {
        //     if (headers.has('Content-Type') === false) {
        //         headers.append('Content-Type', 'application/multipart-form');
        //     }
        // }
        // else {
        //     headers = new HttpHeaders({
        //         'Content-Type': 'application/multipart-form'
        //     });
        // }
        const endpoint = `/api/v1/config/cart-limit?amount=${amount}`;
        return this.put(endpoint, null, headers);
    }

    getDeliveryCharges() {
        const endpoint = '/api/v1/config/delivery-charges';
        return this.getAll(endpoint);
    }

    updateDeliveryCharges(amount: number, headers?: HttpHeaders) {
        // if (headers) {
        //     if (headers.has('Content-Type') === false) {
        //         headers.append('Content-Type', 'application/multipart-form');
        //     }
        // }
        // else {
        //     headers = new HttpHeaders({
        //         'Content-Type': 'application/multipart-form'
        //     });
        // }
        const endpoint = `/api/v1/config/delivery-charges?amount=${amount}`;
        return this.put(endpoint, null, headers);
    }

    getSegmentList() {
        const endpoint = '/api/v1/config/push/segments';
        return this.getAll(endpoint);
    }

    sendPushNotification(endpoint: string = null, model: PushRequestDto, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/config/push' : endpoint;
        return this.post(endpoint, model, headers);
    }

}
